module.exports = __webpack_public_path__ + "static/footer-crabs-c695e8a002193e4c10a059eca87e12f9.svg";